export default __webpack_public_path__ + "static/media/s-14.cd6d056b.jpg";